import EventEmitter, {
  SHOW_POPUP_BUY_REPORT,
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import { AUTHORIZATION_TYPE } from '../../../../utils/authorization'
import { getIsLock } from '../../../helper'

export const getMapIconFollowUserType = (
  userType,
  isBoughtReportFactSheet,
  orderBusinessCreditReportAction = () => {},
  createDynamicReportAction = () => {},
  downloadFactSheetAction = () => {},
  manageCompanyPortfolioAction = () => {},
  followAlertAction = () => {},
  AUTHORIZATION_API,
) => {
  return {
    'icon-follow': {
      iconClass: 'icon-follow',
      label: (isFollowed) =>
        isFollowed
          ? 'companyAnalysis.common.FOLLOWING'
          : 'companyAnalysis.common.FOLLOW',
      backgroundColor: '#E7F2EB',
      color: '#3DA967',
      isLock: getIsLock(
        userType,
        AUTHORIZATION_API.companyAnalysis.followAlerts,
      ),
      action: followAlertAction,
      lockAction: () => {
        EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
      },
    },
    'icon-folder-plus': {
      iconClass: 'icon-folder-plus',
      label: 'companyAnalysis.common.PORTFOLIOS',
      color: '#FFCD60',
      backgroundColor: '#FCF7EC',
      isLock: getIsLock(
        userType,
        AUTHORIZATION_API.companyAnalysis.addToPortfolio,
      ),
      action: manageCompanyPortfolioAction,
    },
    'icon-sim-card-download': {
      iconClass: 'icon-sim-card-download',
      label: 'companyAnalysis.common.DOWNLOAD',
      color: '#2C73E8',
      backgroundColor: '#F2F7FF',
      isLock: getIsLock(
        userType,
        AUTHORIZATION_API.companyAnalysis.downloadAutomationReport,
      ),
      action: downloadFactSheetAction,
    },
    'icon-pdf': {
      iconClass: 'icon-pdf',
      label: 'companyAnalysis.common.ORDER',
      color: '#E0505B',
      backgroundColor: '#FFEEEF',
      borderRadius: '50%',
      isLock: getIsLock(
        userType,
        AUTHORIZATION_API.companyAnalysis.orderBusinessCreditReport,
      ),
      action: orderBusinessCreditReportAction,
    },
    'icon-description': {
      iconClass: 'icon-description',
      label: 'companyAnalysis.common.CREATE_DYNAMIC_REPORT',
      color: '#0553A5',
      backgroundColor: '#EFF5FF',
      isLock: getIsLock(
        userType,
        AUTHORIZATION_API.companyAnalysis.createDynamicReport,
      ),
      action: () => {
        if (
          AUTHORIZATION_API.companyAnalysis.createDynamicReport[
            userType.userTypeId
          ] === AUTHORIZATION_TYPE.ONLY_ALLOW_FOR_USER_BUY_REPORT &&
          !isBoughtReportFactSheet
        ) {
          EventEmitter.dispatch(SHOW_POPUP_BUY_REPORT)
        } else {
          createDynamicReportAction()
        }
      },
    },
  }
}
